import { useLayoutEffect, useRef, useState } from 'react';

/** Measure the drawing surface so SVG units remain actual CSS pixels. */
export function useElementSize(initialWidth: number, initialHeight: number) {
  const ref = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState({ width: initialWidth, height: initialHeight });

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    function update(width: number, height: number) {
      // Hidden mobile panels keep their last size until they are shown again.
      if (width <= 0 || height <= 0) return;
      setSize(previous => Math.abs(previous.width - width) < 1 && Math.abs(previous.height - height) < 1
        ? previous : { width: Math.round(width), height: Math.round(height) });
    }
    // Match ResizeObserver's content box, including on the first measurement.
    const style = getComputedStyle(element);
    update(element.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight),
      element.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom));
    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (entry) update(entry.contentRect.width, entry.contentRect.height);
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return { ref, ...size };
}
